// // import React,{ lazy,Suspense }                    from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

// import Header from './assets/component/header';
// import Home from './views/home';
// import Error404 from './views/error/404';
// import PrivacyPolicy from './views/privacyPolicy';

// const AppRouter = () => {
// 	return (
// 		<Router>
// 			<Header />
// 			<Routes>
// 				<Route path="/" element={<Home />} />
// 				<Route path="*" element={<Error404 />} />
// 				<Route path="privacyPolicy" element={<PrivacyPolicy />} />
// 			</Routes>
// 		</Router>
// 	);
// };

// export default AppRouter;


import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import Header from './assets/component/header';
import Home from './views/home';
import Error404 from './views/error/404';
import PrivacyPolicy from './views/privacyPolicy';

const Layout = () => {
	const location = useLocation();

	// hide header on privacy policy page
	const hideHeader = location.pathname === '/privacy-policy';

	return (
		<>
			{!hideHeader && <Header />}

			<Routes>
				<Route path="/" element={<Home />} />
				<Route path="/privacy-policy" element={<PrivacyPolicy />} />
				<Route path="*" element={<Error404 />} />
			</Routes>
		</>
	);
};

const AppRouter = () => {
	return (
		<Router>
			<Layout />
		</Router>
	);
};

export default AppRouter;
